import useFetch, { UseFetchResult } from "../../../hooks/fetch/useFetch";
import { Setting } from "../../setting/models/Setting";
import { SettingDefinitionCreate } from "../models/SettingDefinitionCreate";

interface IUseCreateSettingDefinitionReturn {
  fetch: UseFetchResult<Setting, SettingDefinitionCreate>;
}

export const useCreateSettingDefinition =
  (): IUseCreateSettingDefinitionReturn => {
    const fetch = useFetch<Setting, SettingDefinitionCreate>(
      "/api/setting-definitions",
      {
        skipInitialFetch: true,
        withToast: true,
        method: "post",
      }
    );

    return {
      fetch,
    };
  };
